import React, { useEffect, useRef } from 'react';
import Content from '../content/content';
import ApplicationMessages from '../applicationMessages/applicationMessages';
// @ts-ignore
import { Footer, Link, EnvironmentIndicator } from 'arag-ui-lib';
import HeaderContent from '../general/headerContent/headerContent';
import style from './layout.module.scss';
import GENERAL_FUNCTIONS from '../../utils/functions/functions';
import { useAppSelector } from '../../hooks/hooks';
import applicationSettingsProjections from '../../projections/applicationSettings';
import TermsWithLanguageModal from '../termsWithLanguageModal/termsWithLanguageModal';
import applicationUserProjections from '../../projections/applicationUser';
import codes from '../../utils/constants/codes';
import { useTranslation } from 'react-i18next';

type Props = {
    postApplicationCustomerFeedbackAction?: (e: React.SyntheticEvent) => void;
    customerFeedback?: null | string | boolean;
};

const Layout = (props: Props): JSX.Element => {
    const currentCountryCode: string | null =
        useAppSelector(applicationSettingsProjections.getCountry) ?? 'Unknown';
    const aragSocialMediaImages: any = useAppSelector(
        applicationSettingsProjections.getAragSocialMediaImages,
    );
    const { t, i18n } = useTranslation();
    const footerRef = useRef<HTMLDivElement>(null);
    const socialArray: any = i18n.exists('aragSocialMedia')
        ? JSON.parse(t('aragSocialMedia', { returnObjects: true }))
        : null;
    const areTermsConsented: any = useAppSelector(
        applicationUserProjections.selectAreTermsConsented,
    );
    const isModalOpen: any = useAppSelector(
        applicationUserProjections.selectIsModalOpen,
    );

    useEffect(() => {
        if (Array.isArray(socialArray)) {
            document.documentElement.style.setProperty(
                '--sprite-url',
                `url(${aragSocialMediaImages})`,
            );
        }
    }, [socialArray]);

    useEffect(() => {
        if (footerRef.current) {
            const contentHeight = footerRef.current.offsetHeight;
            document.documentElement.style.setProperty(
                '--footer-height',
                `${contentHeight}px`,
            );
        }
    }, []);

    return (
        <div className={'container'}>
            <div className={`${style['content']} form-group`}>
                <HeaderContent />
                <ApplicationMessages />
                {currentCountryCode === codes.canadaCode && (
                    <TermsWithLanguageModal
                        isModalOpen={isModalOpen}
                        areTermsConsented={areTermsConsented}
                    />
                )}
                <Content />
            </div>
            {(codes.enviromentsForIndicator as any)[
                process.env.REACT_APP_ENV_NAME as any
            ] && (
                <EnvironmentIndicator
                    country={GENERAL_FUNCTIONS.getCountryByWindowUrl(
                        currentCountryCode,
                    )}
                    envName={GENERAL_FUNCTIONS.getEnvironmentByWindowUrl()}
                />
            )}
            <footer ref={footerRef} className={`${style['footer']}`}>
                <Footer
                    socialArray={
                        socialArray && Array.isArray(socialArray)
                            ? socialArray
                            : []
                    }
                    registrationText={t('registration')}
                />
            </footer>
        </div>
    );
};

export default Layout;
